export const religionData = [
   {
      label: "Christainity",
      value: "christainity",
   },
   {
      label: "Islam",
      value: "islam",
   },
];

export const relationData = [
   {
      label: "Parent",
      value: "parent",
   },
   {
      label: "Guardian",
      value: "guardian",
   },
   {
      label: "Sibling",
      value: "sibling",
   },
   {
      label: "Relative",
      value: "relative",
   },
   {
      label: "Other",
      value: "other",
   },
];

export const genderData = [
   {
      label: "Male",
      value: "male",
   },
   {
      label: "Female",
      value: "female",
   },
];
